import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['input', 'output']
  static values = {
    observedName: String
  }

  connect() {
    this.toggle()
  }

  toggle() {
    let value = this.inputTarget.value;
    
    this.outputTargets.forEach((el) => {
      el.hidden = value !== this.observedNameValue;
    });
  }
}